import { ErrorHandler } from '@/services/errorHandler/ErrorHandler';
import { errorStackTraceReader } from '@/services/errorHandler/ErrorStackTraceReader';
import { ConsoleErrorService } from '@/services/errorHandler/services/console';
import { SentryService } from '@/services/errorHandler/services/sentry';
import { VGL_ERROR_HANDLER_SERVICE } from '@/services/errorHandler/types';
import type { VGLErrorHandlerService } from '@/services/errorHandler/types';

let errorHandler: ErrorHandler | null = null;

export const useErrorHandler = (): ErrorHandler => {
  const services = new Map<symbol, VGLErrorHandlerService>();

  // To add a new service, create a unique identifier in `VGL_ERROR_HANDLER_SERVICE` and add it to this list
  services.set(
    Symbol(VGL_ERROR_HANDLER_SERVICE.CONSOLE),
    new ConsoleErrorService(),
  );

  services.set(Symbol(VGL_ERROR_HANDLER_SERVICE.SENTRY), new SentryService());

  if (errorHandler === null) {
    errorHandler = new ErrorHandler(services, errorStackTraceReader);
  }

  return errorHandler;
};
